import React from "react";
import styles from "./LandscapeGameCard.module.css";
import Paragraph, { ParagraphSize } from "./Paragraph";
import AutoPlayMutedVideo from "./AutoPlayMutedVideo";
import clsx from "clsx";
import TitleText, { TitleTextSize } from "./TitleText";
import ImageComponent from "./ImageComponent";
import IndicatorVideoImage from "./IndicatorVideoImage";
import { ButtonSize, ButtonType, JokerButton } from "material-ui-jokerpro";
import AssetsPack from "../util/AssetsPack";

interface LandscapeGameCardProps {
  title: string;
  description: string;
  video: string;
  indicatorVideo?: string;
  isHovered?: boolean;
  images?: string;
  onClick?: (type: string) => void;
  type: string;
}

const LandscapeGameCard: React.FC<LandscapeGameCardProps> = ({
  title,
  description,
  video,
  indicatorVideo,
  isHovered,
  images,
  onClick,
  type,
}) => {
  const handleClick = () => {
    onClick?.(type);
  };
  return (
    <div
      className={clsx(
        styles["card-container"],
        isHovered && styles["card-border"]
      )}
    >
      {
        <AutoPlayMutedVideo
          videoSrc={video}
          classNameStyle={clsx(styles["video-container"])}
          isHovered={isHovered}
        />
      }

      <ImageComponent
        src={images}
        className={clsx(
          styles["image-container"],
          isHovered ? styles["scale"] : styles["normal"]
        )}
      />

      {indicatorVideo && (
        <div
          className={clsx(
            styles["card-gametype-video-icon"],
            isHovered && styles["hidden"]
          )}
        >
          <IndicatorVideoImage indicatorUrl={indicatorVideo} />
        </div>
      )}
      <div className={styles["bottom-view-container"]}>
        <div className={`${styles["description-container"]}`}>
          <div className={styles["text-view"]}>
            <TitleText size={TitleTextSize.heading4}>{title}</TitleText>
            <Paragraph
              size={ParagraphSize.paragraph2}
              classNameStyle={styles["description-text"]}
            >
              {description}
            </Paragraph>
          </div>
          <div
            className={clsx(
              styles["button-view"],
              isHovered ? styles["visible"] : styles["hidden"]
            )}
          >
            <JokerButton
              text={"View more"}
              onClick={handleClick}
              type={ButtonType.CTA}
              icon={`${AssetsPack.icons.REDIRECT_ARROW.default}`}
              size={ButtonSize.Medium}
              isFullWidth
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandscapeGameCard;
